import * as React from 'react';

import {CopyIconButton} from 'shells/button/copy-button/copy-icon-button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {TickCircleIcon} from 'shells/icon/svg/tick-circle-icon';
import {Body} from 'shells/typography/body';

type Props = {
    phoneNumber: string;
};

export function ConfirmedPhoneNumber(props: Props) {
    return (
        <div className='flex gap-8 align-center'>
            <Body>SMS number:</Body>
            <Body>{props.phoneNumber}</Body>
            <TickCircleIcon color={colors.green} size={14} alignCenter={true} />
            <CopyIconButton as='div' text={props.phoneNumber} popoverBodyColor='light' />
        </div>
    );
}
